import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import useContentGroups from 'content-management-listing-lib/hooks/useContentGroups';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const KBSelect = ({
  disabled,
  onChange,
  value
}) => {
  const {
    contentGroupPropertyOptions
  } = useContentGroups('KNOWLEDGE_BASE');
  const options = useMemo(() => contentGroupPropertyOptions.map(propertyOption => {
    return {
      text: propertyOption.label,
      value: Number.parseInt(propertyOption.value, 10)
    };
  }), [contentGroupPropertyOptions]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importModal.knowledgeBaseLabel"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.importModal.knowledgeBaseHelpText"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      disabled: disabled,
      menuWidth: "auto",
      options: options,
      onChange: event => onChange(event.target.value),
      value: value
    })
  });
};
export default KBSelect;